// eslint-disable-next-line @typescript-eslint/no-unused-vars
import styles from './app.module.css';

import { Toaster } from '@sandtech-hub-monorepo/ui-kit';

import { AppRouter } from '../routes/appRouter';

export function App() {
  return (
    <>
      <AppRouter />
      {/*
        Global toast host. Without this every `toast(...)` call across the app
        (copy-to-clipboard confirmations, mutation success/error feedback,
        sign-up confirmation) is a silent no-op. Defaults to the light theme
        via ui-kit's ThemeContext default, so no ThemeProvider is required.
      */}
      <Toaster position="top-center" expand />
    </>
  );
}

export default App;
